import { render, staticRenderFns } from "./SaleOrderModal.vue?vue&type=template&id=10470a8c&"
import script from "./SaleOrderModal.vue?vue&type=script&lang=js&"
export * from "./SaleOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports